export default __webpack_public_path__ + "static/media/image-chair-algo-lima-04-l-w.758dadfe.webp";